import React, {useRef} from 'react';
import './LocalPvP.scss';
import Board from "../../Board/Board";
import {_} from "../../../models/Game.model";
import SidebarNav from "../../Nav/NavSidebar";
import {ArrowClockwise, CloudPlus} from "react-bootstrap-icons";

interface Props {
    onSwitchGame: () => void;
}

const LocalPvP = (props: Props) => {
    const ref = useRef<any>();

    const reset = () => {
        ref.current.reset();
    }

    const onBoardClick = (row: number, col: number) => {
        ref.current.update(row, col);
    }

    return (
        <section className="LocalPvP">
            <SidebarNav>
                <button onClick={reset}><ArrowClockwise />New</button>
                <button onClick={props.onSwitchGame}><CloudPlus />Cloud Game</button>
            </SidebarNav>
            <header className="Header">
                Offline PvP
            </header>
            <div className="GameBoard">
                <Board id={1} ref={ref} player={_} onClick={onBoardClick}/>
            </div>
        </section>
    );
}

export default LocalPvP;
